import apiClient from './config';

// ============================================
// PARENT API ENDPOINTS
// ============================================

// Base URL for parent endpoints
const PARENT_BASE = '/parent';

// ============================================
// DASHBOARD
// ============================================
export const parentDashboardAPI = {
  // Get parent dashboard
  getDashboard: () => apiClient.get(`${PARENT_BASE}/dashboard`),
};

// ============================================
// STUDENT MANAGEMENT
// ============================================
export const parentStudentAPI = {
  // Get all students under parent's account
  getStudents: () => apiClient.get(`${PARENT_BASE}/students`),
  
  // Add a new student
  addStudent: (studentData) => apiClient.post(`${PARENT_BASE}/students`, studentData),
  
  // Update student information
  updateStudent: (studentId, studentData) => 
    apiClient.put(`${PARENT_BASE}/students/${studentId}`, studentData),
  
  // Remove student from parent's account
  removeStudent: (studentId) => 
    apiClient.delete(`${PARENT_BASE}/students/${studentId}`),
};

// ============================================
// CONTENT MANAGEMENT
// ============================================
export const parentContentAPI = {
  // Get all parent contents (optionally filtered by student)
  getContents: (params) => apiClient.get(`${PARENT_BASE}/contents`, { params }),
  
  // Add content for a student
  addContent: (studentId, contentData) => 
    apiClient.post(`${PARENT_BASE}/students/${studentId}/contents`, contentData),
  
  // Update parent content
  updateContent: (contentId, contentData) => 
    apiClient.put(`${PARENT_BASE}/contents/${contentId}`, contentData),
  
  // Delete parent content
  deleteContent: (contentId) => 
    apiClient.delete(`${PARENT_BASE}/contents/${contentId}`),
};

// ============================================
// SPENDING TRACKING
// ============================================
export const parentSpendingAPI = {
  // Get spending summary (with optional filters)
  getSpending: (params) => apiClient.get(`${PARENT_BASE}/spending`, { params }),
  
  // Add spending record for a student
  addSpending: (studentId, spendingData) => 
    apiClient.post(`${PARENT_BASE}/students/${studentId}/spending`, spendingData),
};

// ============================================
// PERFORMANCE TRACKING
// ============================================
export const parentPerformanceAPI = {
  // Get student performance records
  getStudentPerformance: (studentId, params) => 
    apiClient.get(`${PARENT_BASE}/students/${studentId}/performance`, { params }),
  
  // Get performance for all students
  getAllPerformance: (params) => 
    apiClient.get(`${PARENT_BASE}/performance`, { params }),
};

// ============================================
// GRADES
// ============================================
export const parentGradeAPI = {
  // Get all available grades
  getGrades: () => apiClient.get(`${PARENT_BASE}/grades`),
};

// ============================================
// ANALYTICS
// ============================================
export const parentAnalyticsAPI = {
  // Get comprehensive analytics for all students or a specific student
  getComprehensive: (params) => 
    apiClient.get(`${PARENT_BASE}/analytics/comprehensive`, { params }),
  
  // Get learning intelligence for a student
  getLearningIntelligence: (studentId, params) => 
    apiClient.get(`${PARENT_BASE}/analytics/learning-intelligence/${studentId}`, { params }),
  
  // Get performance analytics for a student
  getPerformanceAnalytics: (studentId, params) => 
    apiClient.get(`${PARENT_BASE}/analytics/performance/${studentId}`, { params }),
  
  // Get engagement metrics for a student
  getEngagementMetrics: (studentId, params) => 
    apiClient.get(`${PARENT_BASE}/analytics/engagement/${studentId}`, { params }),
  
  // Get ROI metrics for a student
  getROIMetrics: (studentId) => 
    apiClient.get(`${PARENT_BASE}/analytics/roi/${studentId}`),
  
  // Get comparative analytics for a student
  getComparativeAnalytics: (studentId) => 
    apiClient.get(`${PARENT_BASE}/analytics/comparative/${studentId}`),
  
  // Get actionable insights for a student
  getActionableInsights: (studentId) => 
    apiClient.get(`${PARENT_BASE}/analytics/insights/${studentId}`),
};

